import Store from 'lib/Store';
import Collection from 'lib/Collection';
import GroupStore from 'groups/stores/GroupStore';
import Relationship from 'entities/Relationship';
import { ActionTypes as ChatActionTypes } from 'chat/constants/ChatConstants';
import { ActionTypes } from 'constants/RelationshipConstants';

// @ts-expect-error ts-migrate(2339) FIXME: Property 'extend' does not exist on type 'typeof C... Remove this comment to see the full error message
const Relationships = Collection.extend({ model: Relationship });

class RelationshipStore extends Store {
  getInitialState() {
    return {
      relationships: new Relationships(),
    };
  }

  getRelationship(relationshipId: Backbone$Id): Relationship | undefined | null {
    return this.state.relationships.get(relationshipId);
  }

  addRelationship(relationship: any): void {
    this.state.relationships.add(relationship);
  }

  removeRelationship(relationship: any): void {
    this.state.relationships.remove(relationship);
  }

  getRelationshipWithUser(userId: any): Relationship | undefined | null {
    return this.state.relationships.find(
      // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'relationship' implicitly has an 'any' t... Remove this comment to see the full error message
      (relationship) => relationship.getRelatedUser().id === userId
    );
  }

  handleDispatch(action: any): void {
    switch (action.type) {
      case ActionTypes.LOAD_RELATIONSHIP:
      case ActionTypes.UPDATE_RELATIONSHIP:
        this.waitFor([GroupStore]);
        this.addRelationship(action.relationship);
        this.emitChange();
        break;
      case ActionTypes.DELETE:
        this.waitFor([GroupStore]);
        this.removeRelationship(this.getRelationshipWithUser(action.userId));
        this.emitChange();
        break;
      case ChatActionTypes.CREATE_CHAT: {
        const otherUserId = action.chat.getOtherChatMembers()[0].id;
        if (action.chat.isGroupChat()) {
          break;
        }
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'relationship' implicitly has an 'any' t... Remove this comment to see the full error message
        this.state.relationships.forEach((relationship) => {
          const relatedUserId = relationship.getRelatedUser().id;
          if (otherUserId === relatedUserId) {
            relationship.set('chat', action.chat);
          }
        });
        this.emitChange();
        break;
      }
      default:
        break;
    }
  }
}

export default new RelationshipStore();
